// The ONE module-scope owner of the shell's deferred shared-library
// delegates that more than one shell file reads.
//
// WHY ONE OWNER. frank hoists every module-scope declaration a function reads
// into ONE flat globalScope, so a name carries one value for the whole
// published bundle. These delegates used to be re-declared in every file that
// read them (17 copies of shellStripWorkspacePrefix, 6 of shellGetAiService,
// four of workspaceSettingsForWrite and of the bundle-sentence helper, two of
// shellParseWorkspaceProjectPath), and the copies drifted apart in text —
// frank's module-scope-name-conflict check refuses that. The files import
// them from here; frank follows the import to this one declaration.
//
// NOT barrel-registered (functions/index.js does not re-export this file):
// these are module helpers, not `el.call` functions.
//
// Deferred-call wrappers, never a module-scope destructure of the shared
// barrel: the shell's modules load INSIDE the shared-barrel init cycle (see
// app.js's circular-init note), where `_wsShared.functions` is not yet set.
import _wsShared from '@symbo-ls/workspace-shared'

export const shellStripWorkspacePrefix = (...args) =>
  _wsShared.functions.stripWorkspacePrefix(...args)

export const shellParseWorkspaceProjectPath = (...args) =>
  _wsShared.functions.parseWorkspaceProjectPath(...args)

// `this` passes through: a caller that invokes it as a method keeps its
// element (functions/index.js's convention for root-reading delegates).
export const shellGetAiService = function (...args) {
  return _wsShared.functions.getAiService.apply(this, args)
}

export const workspaceSettingsForWrite = (...args) =>
  _wsShared.functions.workspaceSettingsForWrite(...args)

// A bundle sentence for a chip, a toast or a page name: through the element's
// polyglot when there is one (every `el.call(...)` caller), the SHIPPED
// ENGLISH value on the headless path (a bare call — the model wire, a
// background pass), never a raw key and never "undefined".
// Self-contained on purpose: frank resolves a module helper read from a
// function whose first parameter is `el` through `el.scope`, and the headless
// call has no element (the emission test revives and calls both paths).
export const shellSay = (el, key) => {
  const v =
    el && typeof el.call === 'function'
      ? el.call('polyglot', key)
      : _wsShared.functions.i18nStaticEnglish()[key] || key
  return v == null ? '' : String(v)
}
